<template lang="pug">
  v-container {{ pricePerView }}
    v-row
      v-col(:cols="12")
        div.mx-auto.text-center Le 
          span(style="font-weight: bold") ko-Don
          |  vous permet de faire un don de manière originale. Ce sont les utilisateurs qui, par le 
          span(style="font-weight: bold") don gratuit,
          |  vont distribués aux associations votre ko-Don
      v-col.mt-8(:cols="12")
        div.mx-auto.text-center(style="color: #333")
          span(:style="{ color: $theme.primary.color, fontWeight: `bold` }") 95%
          |  du montant est redistribué aux assos
      v-col(:cols="12")
        illustration-state(
          :illustration="superhero"
          :height="100")
      v-col.text-center
        v-btn(
          @click="percent"
          text) En savoir plus
    v-form(v-model="form")
      v-container.pa-0
        v-row
          v-col(:cols="12")
            v-text-field(
              v-model="name"
              :rules="[value => !!value || `Le nom est requis.`, $createLengthRule({ max: 20, label: `Le nom` })]"
              label="Nom de votre campagne ko-Don"
              :counter="20"
              filled)
          v-col(:cols="12")
            v-text-field(
              v-model="endingMessage"
              :rules="[$createLengthRule({ max: 200, label: `Le message de fin d'annonce` })]"
              label="Message à faire passer"
              hint="exemple : Faire pipi sous la douche permet d'économiser des milliers de litres chaque année. Vous savez ce qu'il vous reste à faire ;)"
              :counter="200"
              filled)
          v-col(:cols="12")
            input-money(
              v-model="price"
              :rules="[() => price > 0 || `Le prix est requis.`, () => price >= 300 || `Le prix doît être supérieur à 3€`]"
              required
              :label="isAdmin ? `Prix reversé aux assos` : `Montant du Ko-Don - prix de la diffusion`"
              filled)
          v-col(
            v-if="!isAdmin"
            :cols="12")
            v-text-field(
              :value="viewsCountTotal"
              label="Nombre de dons gratuits que vous permettez"
              type="Number"
              :disabled="!isAdmin"
              filled)
          v-col(
            v-else
            :cols="12")
            v-text-field(
              v-model.number="viewsCountTotalAdminSet"
              :rules="[value => !!value || `Champs requis.`]"
              label="Nombre de visionnages"
              type="Number"
              filled)
          v-col(
            v-if="isAdmin"
            :cols="12")
            v-alert(
              :color="$theme.background.color"
              type="info") Vous êtes admin, la publication est gratuite !
</template>

<script>
import { page, injectRouteState } from '@iez/core'
import router, { routeCurrent } from '@iez/core/router/'
import { computed, reactive, toRefs, ref } from '@vue/composition-api'
import InputMoney from '@iez/components/inputs/money/'
import data from '@iez/lib/data/'
import waitFor from '@iez/lib/wait-for/'
import InputUrl from '@iez/components/inputs/url/'
import InputVideo from '@iez/components/inputs/video/'
import InputImage from '@iez/components/inputs/image/'
import createOnClick from '@iez/lib/create-on-click/'
import superhero from '@iez/illustrations/Superhero'
import IllustrationState from '@iez/components/illustration-state/'


export default {

  components: {
    IllustrationState,
    InputMoney,
    InputUrl,
    InputVideo,
    InputImage
  },

  setup () {
    const me = data.me({
      fields: [
        `id`,
        `isAdmin`
      ]
    })

    const viewsCountTotalAdminSet = ref(1)

    const isAdmin = computed(() => !!me.value?.isAdmin)

    const duration = computed(
      () => routeState?.file?.duration
    )

    const type = routeCurrent.params.type

    const payload = {
      isAdmin: false,
      name: ``,
      endingMessage: ``,
      endingUrl: ``,

      file: undefined,
      price: undefined,
      type,


      pricePerView: computed(
        () => !isAdmin.value
          ? 1
          : routeState.price / viewsCountTotalAdminSet.value
      ),

      viewsCountTotal: computed(
        () => isAdmin.value
          ? viewsCountTotalAdminSet.value
          : Math.floor(
            routeState.price / routeState.pricePerView
          )
      )
    }
    const routeState = injectRouteState({
      payload
    })

    waitFor({
      dependencies: () => me.value,
      predicate: () => !!me.value
    }).then(me => {
      routeState.isAdmin = me.isAdmin
    })

    const state = reactive({
      form: null,

      ...toRefs(routeState),
      topBarTitle: `Ajout ko-Don`
    })

    page.topBar.set({
      title: computed(() => state.topBarTitle)
    })

    page.bottomAction.set(
      () => state.form
        ? ({
          side: {
            subtitle: `Je confirme avoir lu, et accepté les CGU de Yako.`
          },
          action: {
            label: `Valider`,
            
            onClick: createOnClick({
              validate: () => {
                if (isAdmin.value) {
                  page.confirm({
                    title: `Es-tu sûr ?`,
                    content: `Cela va créer une campagne kodon gratuitement.`,
                    callback: () => {
                      router.push({
                        name: `AddUploading`
                      })
                    }
                  })
                } else {
                  router.push({
                    name: `AddPayment`
                  })
                }
              }
            })
          }
        }) : null
    )
    const sorry = () => {
      page.blockingDialog.set({
        title: `Essayez ultérieurement`,
        content: `Cette fonctionnalité n'est pas disponible pour le moment. Nous travaillons d'arrache-pied pour son arrivée prochaine. Merci de votre compréhension.`,
        action1: {
          label: `Fermer`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
    }

    const percent = () => {
      page.blockingDialog.set({
        content: `Les 5% restants permettent de financer le service de paiement sécurisé ainsi que notre plateforme. Nous travaillons très dur pour que prochainement, 100% du montant soit redistribué aux associations sous forme de dons gratuits.`,
        action1: {
          label: `Compris`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
    }

    return {
      ...toRefs(state),
      isAdmin,
      sorry,
      percent,
      superhero,
      viewsCountTotalAdminSet,
      routeState,
      duration
    }
  }
}
</script>
